import { getMessaging } from 'firebase/messaging/sw';
import { getToken } from 'firebase/messaging';
import { getApp } from 'firebase/app';
import { getDeviceAndUserStore } from '../storage/stores';
import * as qinit from '../qinit';
import { PUSH_TAG } from './constants';

/**
 * Obtain FCM token in Service Worker context
 *
 * Gets token from Firebase (initialized in messaging.ts) and stores it
 * in DeviceAndUserStore.fcm.pushToken.
 *
 * @throws Error when VAPID key is missing or token cannot be obtained
 */
export const obtainFcmToken = async (): Promise<void> => {
  const vapidKey =
    qinit.tenant.chromebook.pushNotificationConfig?.vapidKey?.key;
  if (!vapidKey) {
    console.warn(`${PUSH_TAG} Firebase vapidKey config not available`);
    return;
  }

  const firebase = getApp();
  const messaging = getMessaging(firebase);
  const token = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: (
      globalThis.self as unknown as {
        registration: ServiceWorkerRegistration;
      }
    ).registration,
  });

  const deviceUserStore = getDeviceAndUserStore();
  const currentFcmInfo = deviceUserStore.get()?.fcm ?? {};

  await deviceUserStore.set({
    fcm: {
      ...currentFcmInfo,
      pushToken: token,
    },
  });
};
